import { Components, Theme } from '@mui/material';

export const MuiListItemButton: Components<
  Omit<Theme, 'components'>
>['MuiListItemButton'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: theme.shape.borderRadius,
    }),
  },
};
